// eslint-disable-next-line @nx/enforce-module-boundaries
import { Button, CircularProgress, Stack, Typography } from '@mui/material';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { Page } from '@occc-app/design-system';
import { Card } from '@occc/ui-design-system';

type FileDownloadPageProps = {
  pageTitle: string;
  title: string;
  subtitle: string;
  onDownload: () => void;
  loading: boolean;
};

export const FileDownloadPage = ({
  pageTitle,
  title,
  subtitle,
  onDownload,
  loading = false,
}: FileDownloadPageProps) => {
  return (
    <Page
      browserTabTitle={pageTitle}
      pageHeaderProps={{
        title: pageTitle,
      }}
    >
      <Stack
        component={Card}
        justifyContent='center'
        alignItems='center'
        px={3}
        spacing={3}
        minHeight={480}
      >
        <Typography component='h2' variant='h4'>
          {title}
        </Typography>

        <Typography variant='body1' color='textSecondary'>
          {subtitle}
        </Typography>

        <Button
          variant='contained'
          onClick={onDownload}
          disabled={loading}
          startIcon={loading ? <CircularProgress size={20} /> : null}
        >
          {loading ? 'Downloading…' : 'Download File'}
        </Button>
      </Stack>
    </Page>
  );
};
